import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { QuestionBase } from 'src/app/common/question-base';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.css']
})
export class QuestionComponent implements OnInit {

  selectedOption: string = "";
  selectedOptions: number[] = [];
  selectedCount: number;

  @Input() hint: string;
  @Input() markers: any[];
  @Input() placeholder: string;
  @Input() question: QuestionBase<string>;
  @Input() form: UntypedFormGroup;
  @Input() qNo: number;
  @Input() qId: number;
  @Input() validity: boolean;
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() submitted: boolean;
  @Input() isNumbered: boolean;
  @Input() isSubnumbered: boolean;
  @Input() optionCount: number;

  invalid_domains: string[] = [
    // "gmail.com",
    // "yahoo.com",
    // "hotmail.com",
  ];

  constructor(private changeDetectorRef: ChangeDetectorRef, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    // console.log(this.optionCount);
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  shouldIndent() {
    return (this.isNumbered || this.isSubnumbered);
  }

  selected(event, question) {
    // console.log(event);
    // console.log(event.source.selected);
    // console.log("set: " + question.selection);

    this.selectedOptions.push(event.source.selected.id);
    this.selectedCount = event.source.selected.length;

    // console.log(this.selectedOptions);
  }

  onSelected(event, question) {

    let selection = parseInt(event.target.id);

    if (event.target.checked) {
      if (!this.selectedOptions.includes(selection)) {
        this.selectedOptions.push(selection);
      }
    } else {
      if (this.selectedOptions.includes(selection)) {
        this.selectedOptions.forEach((option, index) => {
          if (option == selection) {
             this.selectedOptions.splice(index, 1);
          }
        });
      }
    }

    // console.log(this.selectedOptions);

    // console.log(event.source);
    // console.log(event.source.selected);
    // console.log("set: " + question.selection);
  }

  onClick(event, question) {

    if (this.question.options.length) {
      if (event.target.checked) {
        this.selectedOption = this.question.options[0].key;
      } else {
        this.selectedOption = "";
      }
    }

    // console.log(this.selectedOptions);

    // console.log(event.source);
    // console.log(event.source.selected);
    // console.log("set: " + question.selection);
  }

  invalidDomain(email) {
    if (!email.includes('.')) {
      this.form.controls[this.question.key].setErrors({'incorrect': true});
      return (true);
    }

    var resultArray = email.split('@');

    if (resultArray.length > 1) {
      var user = resultArray[0];
      var domain = resultArray[1];

      try {
        if (this.invalid_domains.includes(domain)) {
          this.form.controls[this.question.key].setValue(user + "@");
        }
      } catch (e) {
      }

      return (this.invalid_domains.includes(domain));
    }

    return (false);
  }

  insertMarker(text, id) {
     var result = text;

     if (this.markers) {
       var counter = 0;
       var newStrings = [];
       this.markers.forEach((marker) => {
         var raw = '###' + counter + '###';
         // newStrings.push('<abbr style="text-decoration: none" data-title="' + marker[1] + "&#xa; &#xa;" + marker[2] + '" class="info">ⓘ</abbr><span class="circle"></span>');
         newStrings.push('<span data-tooltip="' + marker[1] + "&#xa; &#xa;" + marker[2] + '" class="info">ⓘ</span><span class="circle"></span>');
         result = result.replace(marker[0], raw);
         counter++;
       });
       counter = 0;
       this.markers.forEach((marker) => {
         var raw = '###' + counter + '###';
         result = result.replace(raw, marker[0] + newStrings[counter]);
         counter++;
       });
     }

     return this.sanitizer.bypassSecurityTrustHtml(result);
  }

  get isBlank() { return !this.form.controls[this.question.key].value; }
  get isValid() { return this.form.controls[this.question.key].valid; }
  get isTouched() { return this.form.controls[this.question.key].touched; }
  get isDirty() { return this.form.controls[this.question.key].dirty; }
  get emailBusinessError() { return this.invalidDomain(this.form.controls[this.question.key].value); }
  get emailError() { return (this.form.controls[this.question.key].hasError('email')); }
  get patternError() { return this.form.controls[this.question.key].hasError('pattern'); }

}
